<template>
  <div class="groupRulesEdit">
    <b-row>
      <b-col cols="12">
        <span>
          <strong>Als...</strong>
        </span>

        <ol class="px-4 pt-4 mb-2">
          <li
            class="group-rule"
            v-for="(rule, index) in rules"
            :key="`group-rule-${index}`"
          >
            <b-row>
              <b-col
                cols="12"
                class="
                  d-flex
                  flex-row
                  col-12
                  align-items-center
                  justify-content-between
                "
              >
                <span>
                  <GroupRuleEdit
                    :rule="rule"
                    :index="index"
                    :editing="isRuleBeingEdited(rule.id)"
                  />

                  <span v-if="index !== rules.length - 1">, en...</span>
                </span>

                <span class="icons">
                  <b-button-group>
                    <b-button
                      class="bg-transparent text-primary border-0 p-2"
                      v-if="!isRuleBeingEdited(rule.id)"
                      @click="rulesBeingEdited = rule.id"
                    >
                      <i class="far fa-pencil" />
                    </b-button>

                    <b-button
                      @click="removeRule(rule)"
                      class="bg-transparent text-danger border-0 p-2"
                    >
                      <i class="fas fa-trash" />
                    </b-button>
                  </b-button-group>
                </span>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
            </b-row>
          </li>
        </ol>

        <b-row>
          <b-col
            cols="12"
            class="
              d-flex
              col-12
              align-items-center
              justify-content-between
              mb-4
              pr-5
            "
          >
            <span>
              <strong>...dan wordt de order op hold gezet. </strong>
            </span>

            <b-button @click="createRule" variant="outline-primary">
              <i class="fas fa-plus" />
              <span class="ml-2">Nieuwe regel toevoegen</span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GroupRuleEdit from "./GroupRuleEdit.vue";
export default {
  name: "GroupRulesEdit",
  props: {
    rules: {
      type: Array,
      required: true,
    },
  },

  components: { GroupRuleEdit },

  data() {
    return {
      editing: [], // array with rule IDs that are being edited
    };
  },

  computed: {
    rulesBeingEdited: {
      get: function (id) {
        return this.editing;
      },
      set: function (id) {
        this.editing.push(id);
      },
    },
  },

  methods: {
    isRuleBeingEdited(id) {
      return this.editing.includes(id);
    },

    createRule() {
      this.$emit("createRule");
    },

    removeRule(rule) {
      this.$emit("removeRule", rule);
    },
  },
};
</script>